import { useState } from "react";
import { toast } from "../lib/notify";
import { FileDown, Upload, ShieldAlert } from "lucide-react";
import { http, formatApiError, downloadUrl } from "../lib/api";
import UploadErrorsButton from "./projects/UploadErrorsButton";

// SGK işyeri no eksik şubeler için Excel indir → doldur → yükle
export default function SgkBulkUpload({ projectId, missingCount, onSaved, compact = false }) {
  const [file, setFile] = useState(null);
  const [lastFile, setLastFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  if (!missingCount) return null;

  const upload = async () => {
    if (!file) return;
    setBusy(true); setResult(null);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await http.post(`/projects/${projectId}/sgk-upload`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      setResult(data); setLastFile(file);
      toast.success(`${data.updated} şubenin SGK bilgisi güncellendi${data.skipped ? `, ${data.skipped} satırda SGK no boş (atlandı)` : ""}`);
      if (data.errors.length) toast.error(`${data.errors.length} satır eşleşmedi`);
      setFile(null);
      onSaved?.();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };

  return (
    <div className={compact ? "space-y-2" : "rounded-md border-2 border-red-300 bg-red-50/50 p-3 space-y-2"} data-testid="sgk-bulk-panel">
      <div className="flex items-center gap-2 flex-wrap">
        <ShieldAlert className="w-4 h-4 text-red-700" />
        <span className="text-xs font-bold text-red-800" data-testid="sgk-bulk-title">{missingCount} şubede SGK işyeri no eksik</span>
        <span className="text-[11px] text-red-700">— Excel'i indirin, SGK İşyeri No (ve isteğe bağlı e-Bildirge bilgilerini) doldurup geri yükleyin. Yalnız dolu gelen alanlar yazılır.</span>
        <div className="ml-auto flex items-center gap-2 flex-wrap">
          <a href={downloadUrl(`/projects/${projectId}/sgk-missing-template`)} target="_blank" rel="noreferrer" data-testid="sgk-bulk-template"
            className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md border border-red-700 text-red-800 bg-white text-xs font-semibold hover:bg-red-100">
            <FileDown className="w-3.5 h-3.5" /> SGK Eksik Excel
          </a>
          <input type="file" accept=".xlsx,.xlsm" data-testid="sgk-bulk-file" onChange={(e) => { setFile(e.target.files?.[0] || null); setResult(null); }} className="text-[11px] text-slate-600 max-w-[190px]" />
          <button type="button" onClick={upload} disabled={!file || busy} data-testid="sgk-bulk-upload"
            className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md bg-red-700 text-white text-xs font-semibold hover:bg-red-800 disabled:opacity-50">
            <Upload className="w-3.5 h-3.5" /> {busy ? "Yükleniyor…" : "SGK Yükle"}
          </button>
        </div>
      </div>
      {result?.errors?.length > 0 && (
        <div className="bg-white border border-red-200 rounded-md p-2 space-y-0.5" data-testid="sgk-bulk-errors">
          <UploadErrorsButton file={lastFile} errors={result.errors} name="SGK" testid="sgk-bulk-errors-xlsx" />
          {result.errors.slice(0, 10).map((er) => <div key={er.row} className="text-[11px] text-red-700">Satır {er.row}: {er.message}</div>)}
        </div>
      )}
    </div>
  );
}
